const plaidLinkScriptSrc = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';

class PlaidService {
    constructor() {
        this.handler = null;
        this.scriptElement = null;
    }

    init() {
        return this.constructor.loadScript();
    }


    static loadScript() {
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            document.body.appendChild(scriptElement);
            scriptElement.onload = resolve;
            scriptElement.onerror = reject;
            scriptElement.src = plaidLinkScriptSrc;
        });
    }

    create(config) {
        this.handler = window.Plaid.create(config);
    }

    open() {
        return new Promise((resolve, reject) => {
            if (!this.handler) {
                reject(new Error('No handler'));
            }
            this.handler.open();
            resolve();
        });
    }

    destroy() {
        if (this.handler) {
            this.handler.destroy();
        }
    }

    static handleError(err) {
        let text = `${err.error_type}: ${err.error_code} - ${err.error_message}`;
        if(err.error_code === 'MFA_NOT_SUPPORTED') {
            text = 'If you have Two-Factor Authentication (2FA) set up, please turn it off before authenticating.';
        }

        return text;
    }
}

export default PlaidService;
